import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const AttorneysPage = lazy(() => import('../pages/attorneys/page'));
const AttorneyProfilePage = lazy(() => import('../pages/attorney-profile/page'));
const PracticeAreasPage = lazy(() => import('../pages/practice-areas/page'));
const PracticeAreaDetailPage = lazy(() => import('../pages/practice-area-detail/page'));
const LegalInsightsPage = lazy(() => import('../pages/legal-insights/page'));
const ArticleDetailPage = lazy(() => import('../pages/article-detail/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/attorneys',
    element: <AttorneysPage />,
  },
  {
    path: '/attorney-profile/:id',
    element: <AttorneyProfilePage />,
  },
  {
    path: '/practice-areas',
    element: <PracticeAreasPage />,
  },
  {
    path: '/practice-areas/:slug',
    element: <PracticeAreaDetailPage />,
  },
  {
    path: '/legal-insights',
    element: <LegalInsightsPage />,
  },
  {
    path: '/legal-insights/:slug',
    element: <ArticleDetailPage />,
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;